"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARRAY_TENANT = ["ID", "MY", "PH", "SG", "TW", "TH", "VN", "BR"];
exports.COOKIE_USER_ID_TEST = "SPC_TEST";
exports.HOST_PREFIX_BY_ENV = {
    test: 'https://test.',
    uat: 'https://uat.',
    production: 'https://'
};
exports.DOMAIN_BY_TENANT = {
    ID: "shopee.co.id",
    MY: "shopee.com.my",
    PH: "shopee.ph",
    SG: "shopee.sg",
    TH: "shopee.co.th",
    TW: "shopee.tw",
    VN: "shopee.vn",
    BR: "shopee.com.br"
};
exports.ERR_CONNECTION_IMG_URL = "https://cf.shopee.co.id/file/9dad5c0bdad73e9b452ff285b5c1f41a";
exports.ERR_RESPONSE_IMG_URL = "https://cf.shopee.co.id/file/8aa358c4ebc834bd362e8e4a4dfba3f6";
exports.SHOPEE_LOGO_IMG_URL = "https://cf.shopee.co.id/file/c999c60cae7ce5a0e3afe23c78cfe474";
//# sourceMappingURL=constant.js.map